<template>
    <el-radio-group v-model="value" @change="_change">
        <div v-if="!hasBtn">
            <el-radio v-for="(option, Index) in options" :key="Index" :label="hasBasicTypes ? option : option[keys]" :disabled="option.disabled" :border="border" :size="size">{{
                hasBasicTypes ? option : option[text]
            }}</el-radio>
        </div>
        <div v-else>
            <el-radio-button v-for="(option, Index) in options" :key="Index" :label="hasBasicTypes ? option : option[keys]" :disabled="option.disabled" :border="border" :size="size">{{
                hasBasicTypes ? option : option[text]
            }}</el-radio-button>
        </div>
    </el-radio-group>
</template>

<script>
export default {
    props: {
        value: {},
        /* 数据源 */
        options: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 关键字 */
        keys: {
            type: String,
            default: function() {
                return 'value';
            }
        },
        /* 显示文字的关键字 */
        text: {
            type: String,
            default: function() {
                return 'label';
            }
        },
        /* 是否显示边框 */
        border: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* medium / small / mini */
        size: {
            type: String
        },
        /* 是否为按钮类型 */
        hasBtn: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 是否绑定为基本类型类型 */
        hasBasicTypes: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    data() {
        return {
            /* 是否满足显示权限 */
            permissionsShow: true
        };
    },
    watch: {
        value(newval) {
            this.value = newval;
        }
    },
    methods: {
        _change(value) {
            this.$emit('input', value);
            this.$emit('change', value);
        }
    }
};
</script>
